import { ENV } from '../configs/appConfig';
import axios from '../services/httpService';
import Developer from '@src/assets/images/engineers/development.svg';
import Lead from '@src/assets/images/engineers/Lead.svg';
import MainDeveloper from '@src/assets/images/engineers/MainDeveloper.svg';
import Designer from '@src/assets/images/engineers/designer.svg';
import Devop from '@src/assets/images/engineers/devops.svg';
import Security from '@src/assets/images/engineers/security.svg';
import SQA from '@src/assets/images/engineers/bug.svg';
import SQALead from '@src/assets/images/engineers/SQALead.svg';
import Content from '@src/assets/images/engineers/content.svg';
import Marketing from '@src/assets/images/engineers/marketing.svg';
import Admin from '@src/assets/images/engineers/admin.svg';
import HR from '@src/assets/images/engineers/human-resource.svg';
import BusinessAnalyst from '@src/assets/images/engineers/Business Analyst.svg';
import Business from '@src/assets/images/engineers/business.svg';
import CSM from '@src/assets/images/engineers/CSM.svg';
import EmailMarketing from '@src/assets/images/engineers/email marketing.svg';
import PaidAds from '@src/assets/images/engineers/Paid ads.svg';
import ProjectManager from '@src/assets/images/engineers/project manager.svg';
import Sales from '@src/assets/images/engineers/sales.svg';
import SEO from '@src/assets/images/engineers/SEO.svg';
import SocialMediaMarketer from '@src/assets/images/engineers/social-media Marketer.svg';
import anyDep from '@src/assets/images/engineers/any Dept.svg';
import dayjs from 'dayjs';

export const USER_ROLES = {
  READ_ONLY: 'read_only',
  READ_WRITE: 'read_write',
};

export const DEFAULT_PERMISSIONS = {
  permissions: {
    resources: { read: false, write: false },
    projects: { read: false, write: false },
    engagement_leads: { read: false, write: false },
    logs: { read: false, write: false },
    project_managers: { read: false, write: false },
    performance_sheets: { read: false, write: false },
    csm: { read: false, write: false },
  },
};

export const AVAILABILITY = [
  { value: 0, label: 'Fully Occupied' },
  { value: 2, label: '1~2 hours' },
  { value: 4, label: '3~4 hours' },
  { value: 6, label: '5~6 hours' },
  { value: 8, label: 'Fully Available' },
];
export const ENGAGEMENT_CAPACITY = [
  { value: 8, label: 'Fully Occupied' },
  { value: 2, label: '1~2 hours' },
  { value: 4, label: '3~4 hours' },
  { value: 6, label: '5~6 hours' },
  { value: 0, label: 'Fully Available' },
];
export const EXPECTED_DATE_LABELS = {
  probation_label: 'Probations',
  increment_label: 'Increments',
};

export const TAGS_OPTIONS = [
  { value: 'Active', label: 'Active', color: '#498205' },
  { value: 'Won', label: 'Won', color: '#c19c00' },
  { value: 'Dropped', label: 'Dropped', color: '#da3b01' },
  { value: 'Sleeping', label: 'Sleeping', color: '#004e8c' },
];

export const SLACK_REDIRECT_URL = 'https://invozone.slack.com/app_redirect?channel=';

export const EMAIL_REDIRECT_URL = 'https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=';

export const PRIORITY_OPTIONS = [
  { value: 'low', label: 'Low', color: '#F1E1A6' },
  { value: 'medium', label: 'Medium', color: '#C3E5AE' },
  { value: 'high', label: 'High', color: '#FF6B6B' },
];

export const ENGAGEMENT_TYPE = [
  { label: 'Billed', value: 1 },
  // { label: 'Shadow', value: 4 },
  { label: 'Support', value: 5 },
  { label: 'Parked', value: 2 },
  { label: 'Training', value: 3 },
];
export const ENGAGEMENT_TYPE_CLIENT = [
  { label: 'Billed', value: 1 },
  { label: 'Shadow', value: 4 },
  { label: 'Support', value: 5 },
  { label: 'Parked', value: 2 },
  { label: 'Training', value: 3 },
];
export const ENGAGEMENT_TYPE_INHOUSE = [
  { label: 'Support', value: 5 },
  { label: 'Parked', value: 2 },
  { label: 'Training', value: 3 },
];
export const cleanup = () => {
  localStorage.removeItem('toHighlightOrFilter');
};
export const handleEmailPhone = async (sendId, receiveId, act, em, nm) => {
  const request_body = {
    senderId: sendId,
    receiverId: receiveId,
    action: act,
    email: em,
    name: nm,
  };
  const baseUrl = ENV.baseUrl;
  try {
    const response = await axios.post(`/logs/iconClickEmail`, request_body);
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const handlePhone = async (sendId, receiveId, act, em, nm) => {
  const request_body = {
    senderId: sendId,
    receiverId: receiveId,
    action: act,
    email: em,
    name: nm,
  };
  const baseUrl = ENV.baseUrl;
  try {
    const response = await axios.post(`/logs/iconClickPhone`, request_body);
  } catch (error) {
    console.log(error);
  }
};

export const PAGINATION_PAGE_SIZES = ['10', '20', '80', '160', '800'];
export const DEFAULT_HTTP_ERROR = 'Something went wrong, please try again later';

export const humanize = (str) => {
  var frags = str?.split('_');
  for (let i = 0; i < frags?.length; i++) {
    if (frags[i] != 'TO') frags[i] = frags[i]?.charAt(0)?.toUpperCase() + frags[i]?.slice(1)?.toLowerCase();
    else frags[i] = frags[i]?.toLowerCase();
  }
  return frags?.join(' ');
};

export const roundOffExp = (exp) => Math.round(exp * 2) / 2.0;

export const STATUSE_OPTIONS = [
  { value: 'PRESALE', label: 'Presale' },
  { value: 'ACTIVE', label: 'Active' },
  { value: 'PAUSED', label: 'Paused' },
  { value: 'CLOSING', label: 'Closing' },
  { value: 'CLOSED', label: 'Closed' },
];

export const onBoardEmployeeDefaultData = {
  name: null,
  companyNumber: null,
  email: null,
  designationId: null,
  reporting_manager: null,
  work_shift: null,
  working_location: null,
  fatherName: null,
  personalEmail: null,
  phone_no: null,
  address: null,
  country: null,
  cnic: null,
  bankTitle: null,
  ibanNumber: null,
  accountTitle: null,
  bankAddress: null,
  dob: null,
  gender: null,
  maritalStatus: null,
  emergencyContactName: null,
  emergencyContactNumber: null,
  emergencyContactRelation: null,
  certificationLevel: null,
  fieldOfStudy: null,
  school: null,
  scorePercentage: null,
  degreePassingYear: null,
  departmentId: null,
  subDepartmentId: null,
  contract: null,
  job_status: null,
  contract_start_date: null,
  expected_end_of_probation_date: null,
  end_of_probation_date: null,
  expectedEndOfInternshipDate: null,
  endOfInternshipDate: null,
  permanent_date: null,
  notice_date: null,
  notice_end_date: null,
  currentSalary: null,
  previousSalary: null,
  increment_date: null,
  contract_end_date: null,
};

export const releaseCapacity = (engagementCapacity, currentAvailability, totalAvailability) => {
  let arr = [];
  let options = engagementCapacity + currentAvailability;
  while (options) {
    arr.push({ value: options, label: options === totalAvailability ? `Fully Occupied` : `${options - 1}~${options} hours` });
    options = options - 2;
  }
  arr.push({ value: options, label: `Fully Available` });
  const capacityOptions = arr.sort((a, b) => {
    return a.value - b.value;
  });
  return capacityOptions;
};

export const resourceRoleLogo = (role) => {
  const roleImage =
    role === 'SQA Engineer'
      ? SQA
      : role === 'SQA Lead'
      ? SQALead
      : role === 'Software Engineer'
      ? Developer
      : role === 'Main SW Engineer'
      ? MainDeveloper
      : role === 'Lead SW Engineer'
      ? Lead
      : role === 'UI/UX Designer'
      ? Designer
      : role === 'Security Engineer'
      ? Security
      : role === 'Devops Engineer'
      ? Devop
      : role === 'Content Engineer'
      ? Content
      : // : role === 'Social Media Marketer'
      // ? Marketing
      role === 'HR Recruiter' || role === 'HR Ops Expert' || role === 'HR LnD Expert'
      ? HR
      : role === 'Office Admin'
      ? Admin
      : role === 'Business Analyst'
      ? BusinessAnalyst
      : role === 'CSM'
      ? CSM
      : role === 'Search Engine Optimiser'
      ? SEO
      : role === 'Photo/Videographer & Editor'
      ? PaidAds
      : role === 'Email Marketer'
      ? EmailMarketing
      : role === 'Key Account Handler'
      ? Sales
      : role === 'Business Developer'
      ? Business
      : role === 'Project Manager'
      ? ProjectManager
      : role === 'Social Media Marketer'
      ? SocialMediaMarketer
      : anyDep;
  return roleImage;
};

export const addResourceModalAvailability = (currentAvailability, totalAvailability, engagement) => {
  let val = 0;
  let arr = [];
  if (engagement && engagement.length > 0) {
    engagement.map((el) => (val = val + el.EmployeeProjects.engagementCapacity));
  }

  let options = totalAvailability - val;
  if (options < 0) {
    options = 0;
  }
  while (options) {
    arr.push({ value: options, label: options === totalAvailability ? `Fully Occupied` : `${options - 1}~${options} hours` });
    options = options - 2;
  }
  arr.push({ value: options, label: `Fully Available` });
  const capacityOptions = arr.sort((a, b) => {
    return a.value - b.value;
  });
  return capacityOptions;
};

//background depends upon availability
export const cardBGAvailability = (el) => {
  return (
    (0 === el.currentAvailability && '#ff9292') ||
    (el.totalAvailability === el.currentAvailability && '#96CEB4') ||
    (2 === el.currentAvailability && '#ffb2b2') ||
    (4 === el.currentAvailability && el.totalAvailability !== el.currentAvailability && '#F1E1A6') ||
    (6 === el.currentAvailability && el.totalAvailability !== el.currentAvailability && '#D7BDE2') ||
    (8 === el.currentAvailability && el.totalAvailability !== el.currentAvailability && '#f5cda8') ||
    (10 === el.currentAvailability && el.totalAvailability !== el.currentAvailability && '#C3E5AE')
  );
};

export const checkAvailability = (el) => {
  return 0 === el.currentAvailability
    ? 'Fully Occupied'
    : el.totalAvailability === el.currentAvailability
    ? 'Fully Available'
    : 2 === el.currentAvailability
    ? '1~2 hours'
    : 4 === el.currentAvailability && el.totalAvailability !== el.currentAvailability
    ? '3~4 hours'
    : 6 === el.currentAvailability && el.totalAvailability !== el.currentAvailability
    ? '5~6 hours'
    : 8 === el.currentAvailability && el.totalAvailability !== el.currentAvailability
    ? '7~8 hours'
    : 10 === el.currentAvailability && el.totalAvailability !== el.currentAvailability
    ? '9~10 hours'
    : '';
};

export const getAvailabilityCount = (el, availability) => {
  let result;
  if (availability === 0 || availability === 2) {
    result = el?.filter((item) => item.currentAvailability === availability);
  } else if (availability === 4 || availability === 6 || availability === 8 || availability === 10) {
    result = el?.filter((item) => item.currentAvailability === availability && item.currentAvailability !== item.totalAvailability);
  } else {
    result = el?.filter((item) => item.currentAvailability === item.totalAvailability);
  }
  return result;
};

export const UserPermissionsList = [
  { name: '/home', value: 'home' },
  { name: '/dashboard', value: 'dashboard' },
  { name: '/hrDashboard', value: 'hrDashboard' },
  { name: '/resources', value: 'resources' },
  { name: '/claimRequests', value: 'provident_funds' },
  { name: '/loanRequests', value: 'loan_requests' },
  { name: '/hardware-loss', value: 'hardware_loss' },
  { name: '/loansAllInstallments', value: 'loan_all_instalments' },
  { name: '/installmentHistory', value: 'loan_instalments_history' },
  { name: '/designations', value: 'designations' },
  { name: '/evaluation', value: 'resource_evaluation' },
  { name: '/attendance/', value: 'resources' },
  { name: '/resourceDetail/', value: localStorage.getItem('tab') },
  { name: '/projects', value: 'projects' },
  { name: '/engagementStats', value: 'summary' },
  { name: '/companyDivision', value: 'executive_summary' },
  { name: '/onBoardingReports', value: 'executive_summary' },
  { name: '/offBoardingReports', value: 'executive_summary' },
  { name: '/portfolio', value: 'project_portfolio' },
  { name: '/engageManagers', value: 'engagement_leads' },
  { name: '/skillRequests', value: 'skill_requests' },
  { name: '/csm-client-playbook', value: 'csm' },
  { name: '/severity-sheet', value: 'severity_sheet' },
  { name: '/upsell-oppurtunity', value: 'upsell' },
  { name: '/board', value: 'board' },
  { name: '/organogram', value: 'organogram' },
  { name: '/audit', value: 'logs' },
  { name: '/publicHolidays', value: 'public_holidays' },
  { name: '/projecthistory/', value: localStorage.getItem('tab') },
  { name: '/claimRequest', value: 'claims' },
];

export const checkPermission = (routeName) => {
  if (localStorage.getItem('is_admin') === 'true') return true;
  if (
    routeName === '/monthlyAuditForm' ||
    routeName === '/home' ||
    routeName === '/notifications' ||
    routeName === '/leaves' ||
    routeName === '/my-hardware-requests' ||
    routeName === '/hardware-loss' ||
    routeName === '/claim' ||
    routeName === '/loans' ||
    routeName === '/installments' ||
    routeName === '/providentFund'
  )
    return true;
  let matchedRoute = UserPermissionsList.find((route) => routeName.includes(route.name));
  if (matchedRoute) {
    let userPermission = localStorage.getItem('permissions');
    if (userPermission == 'undefined' || userPermission == null || userPermission == 'null') return false;
    userPermission = JSON.parse(userPermission);
    if (userPermission[matchedRoute.value] && userPermission[matchedRoute.value].read == true) return true;
  }
  return false;
};
